import React, { useState } from 'react';
import { Link } from 'gatsby';
import classnames from 'classnames';
import NewsList from 'components/Elements/NewsList/index';
import Icon from 'components/UI/Icon';
import Filter from 'components/BlogSecFilter';

import useDeviceState from '@/hooks/useDeviceState';
import FiltersData from '@/mocks/blogSecFilter.js';
import NEWS_DATA from '@/mocks/storyNews';
import { BLOG_PAGE } from '@/constants/pagesUrl.js';
import { DESKTOP_KEY } from '@/constants/devices.js';
import * as styles from './blog.module.scss';

const Blog = ({ data }) => {
  const deviceState = useDeviceState();

  const [activeItem, setActiveIndex] = useState('filter_1');
  const [openSearch, setOpenSearch] = useState(false);

  const handleActiveItem = (e) => {
    setActiveIndex({ activeItem: e.target.id });
  };

  const handleChange = () => {
    setOpenSearch(!openSearch);
  };

  return (
    <section className={classnames(styles.section)}>
      <div className="cr-wrap">
        <div>
          <div className={classnames(styles.hero)}>
            <p
              className={classnames(styles.subtitle, 'cr-subheader cr-text-3')}
            >
              {data.subtitle && data.subtitle}
            </p>
            <h2 className={classnames('cr-h2')}>{data.title && data.title}</h2>
          </div>

          {deviceState !== DESKTOP_KEY && (
            <Filter
              filters={FiltersData}
              onActive={handleActiveItem}
              isActiveItem={activeItem}
              onChange={handleChange}
              isOpen={openSearch}
            />
          )}

          <NewsList news={NEWS_DATA} />

          <Link
            to={BLOG_PAGE}
            className={classnames(
              styles.link,
              'cr-btn cr-btn--icon cr-btn--icon-arrow cr-btn--large cr-btn--wide cr-btn--icon-red-txt'
            )}
          >
            Read more
            <Icon name="corner-arrow-small-bold" />
          </Link>
        </div>
      </div>
    </section>
  );
};

export default Blog;
